<template>
  <el-row :gutter="20" class="home-num">
    <el-col :span="4">
      <el-card>
        <div slot="header" class="header">
          <span>学历学位数</span>
        </div>
        <div class="num" v-text="info.study"></div>
      </el-card>
    </el-col>

    <el-col :span="4">
      <el-card>
        <div slot="header" class="header">
          <span>工作经历数 </span>
        </div>
        <div class="num" v-text="info.work"></div>
      </el-card>
    </el-col>

    <el-col :span="4">
      <el-card>
        <div slot="header" class="header">
          <span>专业情况数</span>
        </div>
        <div class="num" v-text="info.patent"></div>
      </el-card>
    </el-col>

    <el-col :span="4">
      <el-card>
        <div slot="header" class="header">
          <span>承担项目数</span>
        </div>
        <div class="num" v-text="info.project"></div>
      </el-card>
    </el-col>

    <el-col :span="4">
      <el-card>
        <div slot="header" class="header">
          <span>著作、论文数</span>
        </div>
        <div class="num" v-text="info.book"></div>
      </el-card>
    </el-col>

    <el-col :span="4">
      <el-card>
        <div slot="header" class="header">
          <span>奖励荣誉数</span>
        </div>
        <div class="num" v-text="info.award"></div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { countHome } from '@/api/home/front.js';

export default {
  data() {
    return {
      info: {}
    };
  },
  methods: {
    get() {
      countHome().then(res => {
        this.info = res;
      });
    }
  },
  created() {
    this.get();
  }
};
</script>

<style lang="scss" scoped>
.home-num {
  .header {
    font-size: 14px;
  }
  .num {
    text-align: center;
    font-size: 30px;
    line-height: 30px;
  }
}
</style>
